export const LINESTRING_GEOMETRY = "LineString"
export const MULTILINESTRING_GEOMETRY = "MultiLineString"
export const LINESTRING_FEATURE_COLLECTION = "FeatureCollection"

export const geoJSONLineTypes = [LINESTRING_GEOMETRY, MULTILINESTRING_GEOMETRY]
